import { render, staticRenderFns } from "./emitFacebeauty.vue?vue&type=template&id=ca763182&scoped=true"
import script from "./emitFacebeauty.vue?vue&type=script&lang=js"
export * from "./emitFacebeauty.vue?vue&type=script&lang=js"
import style0 from "./emitFacebeauty.vue?vue&type=style&index=0&id=ca763182&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca763182",
  null
  
)

export default component.exports